import { startIndustryPresetIntent } from "@/app/lib/industryPresetIntent";
import { getPresetIndustryPresentation } from "../presetIndustryPresentation";
import { courierIndustrySetup } from "./courierIndustrySetup";
import { hairSalonSetup } from "./hairSalonSetup";
import { personalTrainerSetup } from "./personalTrainerSetup";
import type { IndustrySetupDriver } from "./types";

const industrySetupDrivers: Readonly<Record<string, IndustrySetupDriver>> = {
  courier: courierIndustrySetup,
  "personal-trainer": personalTrainerSetup,
  "hair-salon": hairSalonSetup,
};

export function getIndustrySetupDriver(presetCode: string): IndustrySetupDriver | undefined {
  return Object.hasOwn(industrySetupDrivers, presetCode)
    ? industrySetupDrivers[presetCode]
    : undefined;
}

export function hasIndustrySetup(presetCode: string): boolean {
  return getIndustrySetupDriver(presetCode) !== undefined;
}

export function startIndustrySetup(presetCode: string): void {
  const presentation = getPresetIndustryPresentation(presetCode);
  if (hasIndustrySetup(presetCode) && presentation) {
    startIndustryPresetIntent(presentation.publicIndustrySlug);
  }
}
